<template>
    <div class="proInfo">
<!--      <first-Component></first-Component>-->
      <div class="blackImg" v-if="showImg">
        <div style="margin-top: 100px;">
          <span class="btn" @click="showImg=false"></span>
          <el-carousel height="500px"   arrow="always" >
            <el-carousel-item v-for="(item,index) in info.proimg" :key="index">
              <img class="bigImg animated  zoomIn"   style="width:100%;height:100%;cursor: pointer;object-fit: contain;"  :src="`http://www.pan-am.com.cn/upload/${item.PICURL}`">
              <span class="center">

              </span>
              <div class="white"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div style="position: absolute;top:0;left:0;width:100%" id="d1">

      </div>
      <div class="link animated fadeInLeft" >
        <div class="main">
          <span class="title">{{$t('product.link[0]')}}</span>
          <span>{{$t('product.link[1]')}}</span>
          <span>- {{info.proarr.PRONAME}}</span>
        </div>
      </div>
      <div class="mainCon">
        <div class="left" >
          <el-carousel height="400px"   arrow="always" >
            <el-carousel-item v-for="(item,index) in info.proimg" :key="index">
              <img class="bigImg animated  zoomIn"   style="width:100%;height:100%;cursor: pointer;object-fit: contain;"  :src="`http://www.pan-am.com.cn/upload/${item.PICURL}`">
              <span class="center" @click="showImg=true">

              </span>
              <div class="white"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="rightInfo animated fadeInRight">
          <p class="title">{{info.proarr.PRONAME}}</p>
          <div   v-html="info.proarr.MEMO">
          </div>
<!--          <p class="sty">Style # 1710 Fluorescent Red  </p>-->
<!--          <p >SIZES:</p>-->
<!--          <p >  S    M    L    XL    2X    3X    4X    5X </p>-->
<!--           <p >(Size small only has left mic tab)</p>-->
        </div>
      </div>
      <div class="pic animated fadeInUp">
          <img v-for="(item,index) in info.proimg" :src="`http://www.pan-am.com.cn/upload/${item.PICURL}`" alt="" :key="index" style="height:105px;width:105px;object-fit: cover">
<!--          <img src="../assets/proInfo/p2.png" alt="">-->
      </div>
      <p class="t wow fadeInUp">{{$t('product.title2')}}</p>
      <div class="text wow fadeInUp" v-html="info.proarr.CONTENT" :class="{'short':$i18n.locale==='zh-CN'}" >
<!--        <p v-for="(item,index) in list" :key="index">{{item}}</p>-->
      </div>
<!--      <div class="aBtn wow fadeInUp" @click="back">-->

<!--      <Btn-Component text="Back"></Btn-Component>-->
<!--      </div>-->
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
</template>

<script>
  import footComponent from "./foot"
  import firstComponent from "./first"
  import BtnComponent from './btn'
  import {getProductsInfo} from '../util/lang'
  import Scrollbar from 'smooth-scrollbar';
    export default {
        name: "proInfo",
      data(){
          return{
            showImg:false,
            info:{
              proarr:{},
              proimg:[]
            },
            list:[
              '· Ultra-Cool™ 100% polyester mesh.',
              '· Brilliant Trim reflective edging improves low light visibility.',
              '· Brilliant Plus reflective material greatly enhances worker visibility during lowlight and nighttime hours.',
              '· Zipper front closure reinforced with durable webbing.',
              '· Two 1” wide high performance reflective material with 4.5” contrasting color.',
              '· Left and right chest mic tabs.'
            ]
          }
      },
      components:{footComponent,firstComponent,BtnComponent},
      mounted(){
          this.$nextTick(()=>{
            this.getAllPro(this.$route.query.id)
          })
      },
      methods:{
        gotoTop(){
          Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#d1"))
        },
        getAllPro(id){
          const url = `${getProductsInfo( this.$i18n.locale,id)}`
          this.$axios.get(url).then(res => {
            this.info=res.data
            console.log(res.data)
          })
        },
          back(){
            this.$router.go(-1)
          }
      }
    }
</script>

<style scoped>

.proInfo{
  width:100%;
  padding-top: 120px;
}
.link{
  padding: 30px 0;
  width:1280px;
  margin: 0 auto;
  border-bottom: 1px solid rgba(250, 250, 250, 1);
}
.link .main{
  width:1280px;
  margin: 40px auto;
  text-align: left;
}
.link .main span{
  color:#C9382C;
  text-transform: uppercase;
}
.link .main .title{
  color:black;
}
  .mainCon{
    width:1280px;
    margin: 60px auto;
    display: flex;
    flex-direction: row;
  }
  .mainCon .left{
    width:30%;
    position: relative;
    cursor: pointer;
  }
  .center{
    display: block;
    height:80px;
    width:80px;
    z-index: 100000;
    position: absolute;
    left:40%;
    top:40%;
    border-radius: 50%;
    opacity: 0;
    transition: all 2s;
  }
  .center::before{
    content: "\2194";
    position: absolute;
    border-radius: 50px;
    background-color: rgba(255,0,0,.5);
    height: 80px;
    width: 80px;
    line-height: 80px;
    font-size: 30px;
    left: 0;
    top: 0;
    z-index: 500;
    text-align: center;
    color: #fff;
    opacity: 0;
    transition: all 2s;
    transform:rotate(135deg);
  }
  .white{
    position: absolute;
    width:100%;
    height:100%;
    background-color: rgba(255,255,255,.5);
    z-index: 1000;
    left:0;
    top:0;
    opacity: 0;
    transition: all 2s;
  }
  .mainCon .left:hover .white{
    opacity: 1;
  }
.mainCon .left:hover .center{
  opacity: 1;
}
.mainCon .left:hover .center::before{
  opacity: 1;
}
  .mainCon .rightInfo{
    text-align: left;
    padding-left: 5%;
    /*padding-top: 60px;*/
    line-height: 30px;
    font-family: light;
  }
  .mainCon .rightInfo .title{
    font-size: 22px;
    font-weight: bold;
  }
.mainCon .rightInfo .sty{
 font-size: 18px;
  color:rgba(129, 129, 129, 1);
  padding-bottom: 20px;
}
.pic{
  width:1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  padding-left:10%;
}
.pic img{
  transition: all 2s;
  cursor: pointer;
}
.pic img:hover{
  transform: scale(1.05);
}
  .t{
    margin-top: 100px;
    font-weight: bold;
  }
  .text{
    width:1280px;
    margin: 60px auto;
    text-align: left;
  }
  .text p{
    line-height: 30px;
    transition: all 2s;
    color:black;
    cursor: pointer;
  }
  .text p:hover{
    color:rgba(201, 56, 44, 1);
  }
.short p{
  line-height: 25px !important;
}
.aBtn{
  padding-bottom: 60px;
  margin-top: 60px;
}
.blackImg{
   width:100%;
   height:100vh;
   background-color: rgba(0,0,0,.8);
   position: fixed;
   top:160px;
   left: 0;
   z-index: 10000000;
 }
  .btn{
   display: inline-block;
    position: absolute;
    right:30%;
    height:30px;
    width:30px;
    top:80px;
    cursor: pointer;
    border-radius: 50%;
    z-index: 1000;
   transition: all 2s;
  }
  .btn::before{
    content: "\2716";
    font-size: 20px;
    line-height: 30px;
    color:white;
    transition: all 2s;
  }
  .btn:hover{
    transform:rotate(180deg);
    background-color: rgba(0,0,0,.5);
  }
  .btn:hover::before{
    color: #bebebe;
  }
@media screen and (max-width:450px){
  .proInfo{
    overflow: hidden;
  }
  .link{
    width:90%;
    margin-left: 5%;
  }
  .mainCon{
    width:90%;
    margin-left:5%;
    flex-direction: column;
  }
  .mainCon .left{
    width:100%;
  }
  .mainCon .rightInfo{
    padding-left: 0;
    padding-top: 150px;
  }
  .pic{
    width:90%;
    margin-left: 5%;
    padding-left: 0;
    position: absolute;
    top:750px;
    left:0;
    z-index: 1000;
    justify-content: center;
  }
  .text{
    width:90%;
    margin-left: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/proInfo.vue